import React, { useEffect,  useState } from 'react';
import { MenuForm } from '../Menu.js';
import { SecurityElement } from '../elements/security_element.js';
import { useAPICall } from '../../hooks/useAPICall.js';

import { useNavigate } from 'react-router-dom';

import 'react-datepicker/dist/react-datepicker.css';
import { PageMenuElement } from '../elements/page_menu.js';


export function ReportLapsedMembershipForm() {


    const [pageData, setPageData] = useState();
   const [reportData, setReportData] = useState([]);
    
    const navigate = useNavigate();
    

    const { MakeCall } = useAPICall();


    const handleDataFetch = (data) => {
        setPageData(data);
        setReportData(data.components['report_data']);


    }
    useEffect(() => {
        MakeCall('reports/getlapsedmembershipreportdata', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handleDataFetch);
    });


 
    function handleNav(destination, state) {
        navigate(destination, state);
    }
   

   

    function onPageMenuClick(onclickname) {
        switch (onclickname) {
            case 'goback':
                handleNav("/AdminReports");
                break;
           
            default:
                break;
        }
    }


    return (

        <div>

            {SecurityElement(pageData)}
            {MenuForm()}
            
            <div className="contentdiv">
            {PageMenuElement("Reports", [{ "name": "Back", "onclick": "goback" }], onPageMenuClick)}
              
                <div className='formbox'>
                    <div className='formtitle'>Lapsed Membership Report</div>
                    <div className='formrow' key='reports' style={{"paddingBottom":"25px"}}>
                       This report shows all Lapsed or Suspended members as of today.                                         
                    </div>                    
                    
                    {reportData.map((member) => (
                            <div className='gridrow' key={member.idpeveril_member}>
                                <div className='gridcell' style={{ "width": "30%" }}>{member.forename}</div>
                                <div className='gridcell' style={{ "width": "30%" }}>{member.surname}</div>
                                <div className='gridcell' style={{ "width": "30%" }}>{member.status_name}</div>                                
                            </div>
                        ))}
                    
                </div>

           
            </div>
        </div>


    );
}
